<template>
  <div
    id="content"
    class="content"
    style="margin-left:0px;"
  >
    <h1
      class="page-header"
      style="text-align:left"
    >
      商品管理
      <small>/&nbsp;品牌管理</small>
    </h1>

    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->

        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">品牌管理列表</h4>
              </div>
              <!-- end panel-heading -->
              <!-- begin panel-body -->
              <div class="panel-body">
                <form style="margin-top:16px;padding-left:15px;">
                  <fieldset>
                    <div class="form-group row m-b-15">
                      <label class="col-md-1 col-form-label">品牌编号</label>
                      <div class="col-md-2">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="品牌编号"
                          v-model="brandCode"
                        >
                      </div>
                      <label class="col-md-1 col-form-label">品牌名称</label>
                      <div class="col-md-2">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="品牌名称"
                          v-model="brandName"
                        >
                      </div>
                      <label class="col-md-1 col-form-label">企业名称</label>
                      <div class="col-md-2">
                        <el-select
                          v-model="companyId"
                          clearable
                          placeholder="请选择"
                          style="width:100%;font-size:12px;"
                        >
                          <el-option
                            v-for="item in companyList "
                            :key="item.id "
                            :label="item.commerceName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </div>
                      <div class="col-md-1">
                        <a
                          class="btn btn-primary ButtonColor m-r-5"
                          @click="SearchClick()"
                          style="float:right;"
                        >查询</a>
                      </div>
                      <div class="col-md-5"></div>
                      <div class="col-md-11"></div>
                      <div class="col-md-1">
                        <a
                          class="btn btn-primary ButtonColor"
                          @click="AddClick()"
                          style="float:right;"
                        >新增</a>
                      </div>
                    </div>
                    <div class="form-group row m-b-15"></div>
                  </fieldset>
                </form>

                <el-table :data="UserManagementList" border style="width: 100%">
                  <el-table-column prop="ordernumber" label="序号"  width="60"  align="center"></el-table-column>
                  <el-table-column prop="brandCode" label="品牌编号"  align="center"></el-table-column>
                  <el-table-column prop="brandName" label="品牌名称"  align="center"></el-table-column>
                  <el-table-column prop="companyName" label="企业名称"  align="center"></el-table-column>
                  <el-table-column  label="系列数量"  align="center">
                     <template slot-scope="scope">
                       <div @click="SerieseNumberClick(scope.row,scope.index)" style="width:100%;cursor:pointer">{{scope.row.seriesList.length}}<span style="cursor:pointer;color:#348fe2;font-weight:700;">[查看]</span></div>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="140"  align="center">
                    <template slot-scope="scope">
                      <button
                        class="btn btn-primary btn-sm ButtonColor"
                        @click="EditClick(scope.row)"
                      >编辑</button>
                      <button
                        class="btn btn-warning btn-sm ButtonColor"
                        @click="DeleteClick(scope.row)"
                      >删除</button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="PaginationStyle">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageindex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    background
                    :total="totalCount"
                  ></el-pagination>
                </div>
              </div>
              <!-- end panel-body -->
            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->
        </div>
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
    <el-dialog title :visible.sync="outerVisible" width="500px" :before-close="handleClose">
      <div v-if="EditDialog === 2" class="ModelPadding">
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">您确定吗?</div>
        <div class="swal-text" style="text-align:center">您将无法恢复这个文件!</div>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSure"
              :disabled="disabled"
            >确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>

        </div>
      </div>
      <div v-if="EditDialog === 1" class="ModelPadding">
        <div class="swal-title" style="margin-top:0px">{{DialogTitle}}</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="150px"
          class="demo-ruleForm"
          style="width:90%"
        >
          <el-form-item label="品牌名称:" prop="brandName">
            <el-input v-model="ruleForm.brandName" class="DistributorMargin"></el-input>
          </el-form-item>
          <el-form-item label="品牌编号:" prop="brandCode">
            <el-input v-model="ruleForm.brandCode" class="DistributorMargin"></el-input>
          </el-form-item>
          <el-form-item label="备注:" prop="noted">
            <el-input type="textarea" v-model="ruleForm.noted" class="DistributorMargin"></el-input>
          </el-form-item>
        </el-form>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSureEdit('ruleForm')"
              :disabled="disabled"
            >确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <div class="ModelPadding">
        <div style="margin:15px 0 20px;">
          <i class="el-icon-warning" style="color:#e6a23c;font-size:20px;"></i>
          <span style="font-size:18px;">您当前是超管用户，请选择品牌所要新增的企业</span> 
        </div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="150px"
          class="demo-ruleForm"
          style="width:90%"
        >
          <el-form-item label="企业名称:" prop="companyId">
            <el-select
              v-model="ruleForm.companyId"
              clearable
              placeholder="请选择"
              style="width:100%;"
            >
              <el-option
                v-for="item in companyList "
                :key="item.id "
                :label="item.commerceName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm btn btn-primary"
              @click="confirmAdd('ruleForm')"
              :disabled="disabled"
            >确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="dialogVisible = false"
            >取消</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
export default {
  name: "BrandManagement",
  data() {
    var checkbrandCode = (rule, value, callback) => {
      setTimeout(() => {
        if (/[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error("品牌编号不能输入汉字"));
        } else {
          callback();
        }
      }, 1000);
    };
    var checknote = (rule, value, callback) => {
      setTimeout(() => {
        if (
          value !== "" &&
          value !== undefined &&
          value !== null &&
          value.length > 128
        ) {
          callback(new Error("备注不能超过128个字符"));
        } else {
          callback();
        }
      }, 1000);
    };
    return {
      pageSize: 10,
      totalCount: 0,
      pageindex: 1,
      outerVisible: false,
      DialogTitle: "编辑",
      EditDialog: 1,
      CurrentSelection: [],
      CloseShow: false,
      brandName: "",
      brandCode: "",
      disabled: false,
      status: "1",
      searchContent: {},
      StateOptions: [
        {
          label: "删除",
          value: 0
        },
        {
          label: "正常",
          value: 1
        }
      ],
      ruleForm: {},
      rules: {
        brandCode: [
          { required: false, message: "请输入品牌编码", trigger: "blur" },
          { validator: checkbrandCode, trigger: "blur" }
        ],
        brandName: [
          { required: true, message: "请输入品牌名称", trigger: "blur" }
        ],
        noted: [
          { required: false, message: "请输入备注", trigger: "blur" },
          { validator: checknote, trigger: "blur" }
        ],
        companyId: [
           { required: true, message: "请选择企业名称", trigger: "blur" }
        ]
      },
      UserManagementEdit: "",
      TimeValue: "",
      UserManagementList: [],
      currentPage: 1,
      companyId:'',
      companyList:[],
      dialogVisible: false
    };
  },
  watch: {
    pageNo: {
      handler(newName, oldName) {
        if (this.$route.params && this.$route.params.pageNo) {
          this.pageNo = this.$route.params.pageNo;
        }
      },
      immediate: true
    },
    pagesize: {
      handler(newName, oldName) {
        if (this.$route.params && this.$route.params.pagesize) {
          this.pageSize = this.$route.params.pagesize;
        }
      },
      immediate: true
    }
  },
  computed: {
    pageNo: {
      set(val) {
        if (val) {
          this.pageindex = val;
        }
      },
      get() {
        //console.log('我被调用了') //msg1获取值时触发
      }
    },
    pagesize: {
      set(val) {
        if (val) {
          this.pageSize = val;
        }
      },
      get() {
        //console.log('我被调用了') //msg1获取值时触发
      }
    }
  },
  mounted: function() {
    if (this.$route.params.searchContent) {
      this.brandName = this.$route.params.searchContent.brandName;
      this.brandCode = this.$route.params.searchContent.brandCode;
    }
    this.initdata();
    // 企业列表
    this.getCompanyList();
  },

  methods: {
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.initdata();
    },
    handleCurrentChange(val) {
      this.pageindex = val;
      this.initdata();
    },
    SerieseNumberClick(item, index) {
      let searchContent = {};
      searchContent.brandCode = this.brandCode;
      searchContent.brandName = this.brandName;
      eventBus.$emit("SeriesEmit", true);
      this.$router.push({
        name: "SeriesManagement",
        query: {
          brandId: item.brandId,
          pageSize: this.pageSize,
          pageIndex: this.pageindex,
          searchContent: JSON.stringify(searchContent)
        }
      });
    },
  //  编辑的处理函数
    EditClick(row) {
      this.outerVisible = true;
      this.DialogTitle = "编辑";
      this.EditDialog = 1;
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      this.ruleForm = MethodsBus.cloneRow(row);
    },
    // 删除的函数
    DeleteClick(item) {
      this.outerVisible = true;
      this.EditDialog = 2;
      this.CurrentSelection = item;
    },
    // 新增
    AddClick() {
      this.ruleForm = {};
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      this.outerVisible = true;
      this.DialogTitle = "新增";
      this.EditDialog = 1;
    },
    SearchClick() {
      this.pageindex = 1;
      this.initdata();
    },
    // 获取企业列表
    getCompanyList(){
      let that = this;
      const options = {
        url: "distribution/B2cOrderInfoController/parsingUser",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({})
      };
      axios(options)
        .then(response => {
          if (response.data.code == 200) {
            that.companyList = response.data.data.result;
          } else {
            http.handleEorrorCode(response, this);
          }
        })
        .catch(error => {
          http.handleEorrorCode(response, this);
        });
    },
    MakeSureEdit(formName) {
      let that = this;
      if (this.DialogTitle === "编辑") {
        that.$refs[formName].validate(valid => {
          if (valid) {
            that.disabled = true;
            const options = {
              url: "distribution/B2cGoodsBrandController/updateBrand",
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data: Qs.stringify({
                brandId: this.ruleForm.brandId,
                brandCode: this.ruleForm.brandCode,
                brandName: this.ruleForm.brandName.replace(/\s+/g, ""),
                noted: this.ruleForm.noted
              })
            };
            axios(options)
              .then(function(response) {
                that.outerVisible = false;
                that.disabled = false;
                if (response.data.code == 200) {
                  that.initdata();
                  that.$notify({
                    title: "成功",
                    message: "修改成功",
                    type: "success"
                  });
                } else {
                  http.handleEorrorCode(response, that);
                }
              })
              .catch(function(error) {
                that.outerVisible = false;
                that.disabled = false;
                http.handleHttpError(error, that);
              });
          } else {
            this.outerVisible = true;
          }
        });
      } else if (this.DialogTitle === "新增") {
        that.$refs[formName].validate(valid => {
          if (valid) {
            that.disabled = true;
            const options = {
              url: "distribution/B2cGoodsBrandController/addBrand",
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data: Qs.stringify({
                flag: 0,
                brandCode: this.ruleForm.brandCode,
                brandName: this.ruleForm.brandName.replace(/\s+/g, ""),
                noted: this.ruleForm.noted
              })
            };
            axios(options)
              .then(function(response) {
                that.outerVisible = false;
                that.disabled = false;
                if (response.data.code == 200) {
                  if(response.data.message == '新增成功'){
                    that.initdata();
                    that.$notify({
                      title: "成功",
                      message: response.data.message,
                      type: "success"
                    });
                  }else{
                    that.dialogVisible = true;
                  }
                } else {
                  http.handleEorrorCode(response, that);
                }
              })
              .catch(function(error) {
                that.outerVisible = false;
                that.disabled = false;
                http.handleHttpError(error, that);
              });
          } else {
            this.outerVisible = true;
          }
        });
      }
    },
    confirmAdd(formName){
      let that = this;
      that.$refs[formName].validate(valid => {
        if (valid) {
          const options = {
            url: "distribution/B2cGoodsBrandController/addBrand",
            method: "post",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            data: Qs.stringify({
              flag: 1,
              companyId: this.ruleForm.companyId,
              brandCode: this.ruleForm.brandCode,
              brandName: this.ruleForm.brandName.replace(/\s+/g, ""),
              noted: this.ruleForm.noted
            })
          };
          axios(options).then(function(response) {
            if (response.data.code == 200) {
              that.dialogVisible = false;
              that.initdata();
              that.$notify({
                title: "成功",
                message: response.data.message,
                type: "success"
              });
            } else {
              http.handleEorrorCode(response,that);
            }
          })
          .catch(function(error) {
            http.handleHttpError(error, that);
          });
        } else {
          this.dialogVisible = true;
        }
      });
    },
    MakeSure() {
      let that = this;
      that.disabled = true;
      axios
        .post(
          "distribution/B2cGoodsBrandController/deleteBrand?brandId=" +
            this.CurrentSelection.brandId
        )
        .then(function(response) {
          that.outerVisible = false;
          that.disabled = false;
          if (response.data.code == 200) {
            that.initdata();
            that.$notify({
              title: "成功",
              message: "删除成功",
              type: "success"
            });
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          that.disabled = false;
          http.handleHttpError(error, that);
        });
    },
    initdata() {
      let that = this;
      const options = {
        url: "distribution/B2cGoodsBrandController/queryBrand",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          brandCode: that.brandCode,
          brandName: that.brandName,
          cid: that.companyId,
          size: that.pageSize,
          current: that.pageindex
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.totalCount = response.data.data.totalCount;
            for (var i in response.data.data.data) {
              response.data.data.data[i].ordernumber =
                Number((that.pageindex - 1) * that.pageSize) + Number(i) + 1;
            }

            that.UserManagementList = response.data.data.data;
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/CommoditiesList/BrandManagement.vue